import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class OwnerCarrierService {
  private apiUrl = '/ownercarriers';

  constructor(private http: HttpService) { }

  get(ownerId: number): Promise<any> {
    var url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") +'/spring'+ this.apiUrl}`;
    if(ownerId){
        url = url+"?ownerId="+ownerId;
    }
    return this.http.get(url);
  }

  post(
    ownerId: number,
    carrierCd: string,
    typeprintdeliCd: string,
    attrMap: any,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") +'/spring'+ this.apiUrl}`;
    const jsonInput = {
      ownerId: ownerId,
      carrierCd: carrierCd,
      typeprintdeliCd: typeprintdeliCd,
      attrMap: attrMap,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);
  }

  put(
    ownerId: number,
    carrierCd: string,
    typeprintdeliCd: string,
    attrMap: any,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") +'/spring'+ this.apiUrl}/${ownerId}/${carrierCd}`;
    const jsonInput = {
      typeprintdeliCd: typeprintdeliCd,
      attrMap: attrMap,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }

  delete(
    ownerId: number,
    carrierCd: string,
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") +'/spring'+ this.apiUrl}/${ownerId}/${carrierCd}`;
    return this.http.delete(url);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/owner-carrier/owner-carrier.service.ts